import { defineComponent as _defineComponent } from 'vue'
import { checkSearchResult } from '@/utils/search'
import { orderBy } from 'lodash'
import { computed, onMounted, ref } from 'vue'
import { useGetters } from 'vuex-composition-helpers'
import Form from '@/models/form'
import VsTextInput from '@/components/vision/Inputs/VsTextInput.vue'
import VsText from '@/components/vision/VsText.vue'

interface Props {
  forms: Form[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NewFormSelection',
  props: {
    forms: null
  },
  emits: ["select"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'select', value: { formId: string; businessUnitId: string }): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  forms: Form[]
}





const search = ref('')
const selectedBusinessUnit = ref('')

const { getAccessibleHubIds, getRolesForBusinessUnit, getOrganizationId } =
  useGetters('permissions', [
    'getAccessibleHubIds',
    'getRolesForBusinessUnit',
    'getOrganizationId',
  ])

const { getBusinessUnitById } = useGetters('businessUnits', [
  'getBusinessUnitById',
])

const availableBusinessUnits = computed(() => {
  const accessibleBusinessUnits = [
    getOrganizationId.value,
    ...getAccessibleHubIds.value,
  ]
  return accessibleBusinessUnits
    .map((businessUnitId) => {
      const businessUnit = getBusinessUnitById.value(businessUnitId)
      if (!businessUnit) return null
      return businessUnit
    })
    .filter((businessUnit) => {
      return (
        businessUnit != null &&
        filterFormsByBusinessUnitId(businessUnit.id).length > 0
      )
    })
})

const filteredForms = computed(() => {
  return filterFormsByBusinessUnitId(selectedBusinessUnit.value)
})

const searchedForms = computed((): Record<string, Form[]> => {
  const forms = filteredForms.value.filter((a) =>
    checkSearchResult(search.value, a.name)
  )
  let groupedForms = {}
  for (const form of forms) {
    const formCategoryName = form.category?.name ?? 'Uncategorized'
    if (groupedForms[formCategoryName] === undefined) {
      groupedForms[formCategoryName] = []
    }
    groupedForms[formCategoryName].push(form)
  }
  for (const [key] of Object.entries(groupedForms)) {
    groupedForms[key] = orderBy(groupedForms[key], [
      (form) => form.name.toLowerCase(),
    ])
  }
  groupedForms = Object.keys(groupedForms)
    .sort((a, b) => (a.toLowerCase() < b.toLowerCase() ? -1 : 1))
    .filter((key) => groupedForms[key].length > 0)
    .reduce(
      (grouped, key) => Object.assign(grouped, { [key]: groupedForms[key] }),
      {}
    )
  return groupedForms
})

onMounted(() => {
  if (
    selectedBusinessUnit.value === '' &&
    availableBusinessUnits.value.length === 1
  ) {
    selectedBusinessUnit.value = availableBusinessUnits.value[0].id
  }
})

function selectForm(formId: string) {
  emit('select', { formId, businessUnitId: selectedBusinessUnit.value })
}

function selectBusinessUnit(businessUnitId: string) {
  selectedBusinessUnit.value = businessUnitId
}

function filterFormsByBusinessUnitId(businessUnitId: string) {
  return props.forms.filter((f) => {
    const accessGrant = f.accessGrants.find(
      (ag) => ag.businessUnitId === businessUnitId
    )
    if (!accessGrant) return false

    const userRoles = getRolesForBusinessUnit.value(businessUnitId)
    return userRoles.some(
      (role) => !accessGrant.roleRestrictions.includes(role)
    )
  })
}

return { __sfc: true,emit, props, search, selectedBusinessUnit, getAccessibleHubIds, getRolesForBusinessUnit, getOrganizationId, getBusinessUnitById, availableBusinessUnits, filteredForms, searchedForms, selectForm, selectBusinessUnit, filterFormsByBusinessUnitId, VsTextInput, VsText }
}

})